import { createStore, createLogger } from 'vuex';
import { auth } from "./auth.store";
import { task } from "./task.store";
import { dash } from "./dash.store";

export default createStore({
  modules: { auth, task, dash },
  state: {
    login:{
        username: null,
        company:  null,
        servis:   null
    }
  },
  mutations: {
  // Mutations Must Be Synchronous !
  // use: store.commit('setUser','helpdesk')
    setUser(state, username) {
      state.login.username = username;
    },
    setServis(state, servis) {
      state.login.servis = servis;
    },
    setCompany(state, company) {
      state.login.company = company;
    }
  },
  actions: {
  // Actions can contain arbitrary asynchronous operations
  // use: store.dispatch('logout')
  // https://vuex.vuejs.org/guide/actions.html
    login({ commit , state }, username) {
    return new Promise((resolve) => {
      commit('setUser', username);
      localStorage.setItem('login', JSON.stringify(state.login));
      resolve();
    });
    },
    logout({ commit }) {
      localStorage.removeItem('login');
      commit('setUser', null);
    }
  },
  plugins: process.env.NODE_ENV !== 'production' ? [createLogger()] : []
});
